import { emailRegex as email } from "itsf-ui-common";
import { i18n } from "@translations/i18n";
import { BIRTH_DATE_DISPLAY_STRING_REGEX, FULL_DATE_FORMAT } from "@utils/dateFormat";
import { differenceInYears, format, isValid, parse } from "date-fns";

// Wrap a regex using this function if the field is optional
export const optional = (regex: (value: string) => string | undefined) => (value?: string) =>
    value ? regex(value) : undefined;

export const specialAlphaNumericRegex = (value: string) =>
    value && !/[^a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ '-]/.test(value)
        ? undefined
        : i18n.t("control:onlyLetters");

export const phoneRegex = (value: string) => (/^(08[\d]{8})$/.test(value) ? undefined : i18n.t("control:phone"));

export const optionalPhoneRegex = optional(phoneRegex);

export const emailMustMatch = (value: string, emailValue: string | undefined) =>
    value !== emailValue ? i18n.t("control:emailMustMatch") : undefined;

export const dateFormatRegex = (value: string) => {
    if (!value || !BIRTH_DATE_DISPLAY_STRING_REGEX.test(value)) {
        return i18n.t("control:incorrectDateFormat");
    }
    const parsed = parse(value, FULL_DATE_FORMAT, new Date());

    return isValid(parsed) ? undefined : i18n.t("control:incorrectDateFormat");
};

export const minYearValid = (value: string) =>
    value && parse(value, FULL_DATE_FORMAT, new Date()).getFullYear() >= 1900 ? undefined : i18n.t("control:minYear");

export const maxYearValid = (value: string) =>
    value && parse(value, FULL_DATE_FORMAT, new Date()).getFullYear() <= new Date().getFullYear()
        ? undefined
        : i18n.t("control:maxYear", { date: format(new Date(), "yyyy") });

export const over18Valid = (value: string) =>
    differenceInYears(new Date(), parse(value, FULL_DATE_FORMAT, new Date())) >= 18
        ? undefined
        : i18n.t("control:over18");

export const noSpacesRegex = (value: string) =>
    value !== "" && !/\s/.test(value) ? undefined : i18n.t("control:invalidEmailSpace");

export const emailRegex = (value: string) =>
    value !== "" && email.test(value) ? undefined : i18n.t("control:invalidEmail");
